import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">投稿爆料</h2>
          <p className="text-foreground-600 text-sm md:text-base">{contactData.subtitle}</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              {contactData.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/60">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">投稿邮箱</p>
                  <p className="text-sm font-semibold text-foreground-900">{contactData.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/60">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-wechat-line text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">微信联系</p>
                  <p className="text-sm font-semibold text-foreground-900">{contactData.wechat}</p>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <p className="text-xs font-semibold text-foreground-700 mb-2">爆料须知</p>
              {contactData.tips.map((tip, idx) => (
                <div key={idx} className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>{tip}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}